// Reusable amber/ochre "INVESTIGATIONAL" callout — required by regulatory
// to render any time we surface an investigational compound (e.g.,
// Retatrutide while trials are ongoing). Renders on the compound card,
// the detail panel, and inside the stage slider — three appearances
// per the BE Phase A handoff doc.
import { C } from "@/lib/brand";

export default function InvestigationalCallout({
  note,
  size = "md", // "sm" | "md"
  testId = "investigational-callout",
}) {
  const isSmall = size === "sm";
  return (
    <div
      data-testid={testId}
      role="note"
      style={{
        background: C.ochre,
        color: C.ochreDark,
        borderLeft: `3px solid ${C.ochreDeep}`,
        padding: isSmall ? "8px 12px" : "14px 18px",
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        fontSize: isSmall ? 11 : 13,
        lineHeight: 1.5,
      }}
    >
      <span
        aria-hidden
        style={{
          flexShrink: 0,
          fontSize: isSmall ? 11 : 12,
          fontWeight: 800,
          letterSpacing: "0.22em",
          color: C.ochreDark,
          textTransform: "uppercase",
          paddingTop: 1,
        }}
      >
        ⚠ INVESTIGATIONAL
      </span>
      {note && (
        <span style={{ minWidth: 0, color: C.ochreDark }}>
          {note}
        </span>
      )}
    </div>
  );
}
